export default __webpack_public_path__ + "static/media/atlasex_sword.ca096102.bmp";